import { render, staticRenderFns } from "./AssignmentsList.vue?vue&type=template&id=29476240"
import script from "./AssignmentsList.vue?vue&type=script&lang=js"
export * from "./AssignmentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports